var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShareLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#000064"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.54 20.18h-4.287V33h4.287V20.18zM20.823 16.214C20.795 14.957 19.892 14 18.425 14 16.96 14 16 14.957 16 16.214c0 1.231.93 2.216 2.37 2.216h.027c1.495 0 2.426-.985 2.426-2.216zM36 25.65c0-3.938-2.114-5.771-4.936-5.771-2.276 0-3.295 1.244-3.863 2.117V20.18h-4.288c.057 1.203 0 12.82 0 12.82h4.288v-7.16c0-.383.027-.765.14-1.04.31-.765 1.016-1.557 2.2-1.557 1.552 0 2.172 1.175 2.172 2.898V33H36v-7.35z",
    fill: "#000064"
  })));
}
export default SvgIconShareLinkedin;